// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"4cca1cdf","453":"45909a8b"}[chunkId] + ".chunk.js";
};